import { render, staticRenderFns } from "./CompEmailForm.vue?vue&type=template&id=5cd664bc"
import script from "./CompEmailForm.vue?vue&type=script&lang=js"
export * from "./CompEmailForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports